import { logger } from '../logging.service';

type StorageType = 'local' | 'session';

export class StorageService {
  private readonly PREFIX = 'dwt.';

  public get(key: string, type: StorageType = 'local') {
    try {
      return this.getStorage(type).getItem(this.PREFIX + key);
    } catch (error) {
      logger.warn('Storage get error', key, type, error);
    }
  }

  public set(key: string, value: string, type: StorageType = 'local') {
    try {
      this.getStorage(type).setItem(this.PREFIX + key, value);
    } catch (error) {
      logger.warn('Storage set error', key, type, error);
    }
  }

  public remove(key: string, type: StorageType = 'local') {
    try {
      this.getStorage(type).removeItem(this.PREFIX + key);
    } catch (error) {
      logger.warn('Storage remove error', key, type, error);
    }
  }

  public getItem<T>(key: string, type: StorageType = 'local') {
    const itemString = this.get(key, type);
    if (!itemString) {
      return;
    }
    try {
      return JSON.parse(itemString) as T;
    } catch (error) {
      logger.warn('Storage getItem error', key, type, error);
    }
  }

  public setItem<T>(key: string, item: T, type: StorageType = 'local') {
    try {
      this.set(key, JSON.stringify(item), type);
    } catch (error) {
      logger.warn('Storage getItem error', key, type, error);
    }
  }

  public clear() {
    this.getStorage('local').clear();
  }

  private getStorage(type: StorageType) {
    return type === 'local' ? window.localStorage : window.sessionStorage;
  }
}

export const storageService = new StorageService();
